import { useMemo, useState } from 'react'
import classes from './ChatWidget.module.scss'
import { ChatBasketCommissionRates } from './types'
import { formatInstallmentLabel } from './commissionRatesService'
import {
  activeScopeOf,
  campaignDetailParts,
  defaultTabCode,
  rowsOfScope,
  scopesOfTab,
} from './basketCommissionRatesService'
import { formatChatRate } from './chatFormatters'

interface Props {
  rates: ChatBasketCommissionRates
}

/**
 * Sepet (İyzico) komisyon oranları kartı. İlk sekme DAİMA "Genel" (taban oranlar); şirket
 * sekmesi yalnız o şirkette bayiye açık aktif kampanya varsa gelir — kampanyasız şirket
 * sekme almaz, genel oranlar yine "Genel" sekmesinde durur.
 *
 * Tüm veri payload'da olduğu için sekme/chip geçişleri saf state değişimidir: kart kendi
 * isteğini atmaz ve geçmişten geri yüklenen balonlarda da çalışır. Seçim mantığı
 * `basketCommissionRatesService` içindeki saf fonksiyonlardadır (test edilebilirlik).
 */
export default function BasketCommissionRatesCard({ rates }: Props) {
  const [tabCode, setTabCode] = useState(() => defaultTabCode(rates))
  const [scopeCode, setScopeCode] = useState('')

  const scopes = useMemo(() => scopesOfTab(rates, tabCode), [rates, tabCode])
  const activeScope = activeScopeOf(scopes, scopeCode)
  const rows = useMemo(() => (activeScope ? rowsOfScope(rates, activeScope.code) : []), [rates, activeScope])
  const detail = campaignDetailParts(activeScope)

  if (rates.tabs.length === 0 || !activeScope || rows.length === 0) return null

  return (
    <div className={classes.commissionCard}>
      {rates.title && <div className={classes.commissionTitle}>{rates.title}</div>}

      {rates.tabs.length > 1 && (
        <div className={classes.commissionTabs} role='tablist'>
          {rates.tabs.map(tab => (
            <button
              key={tab.code}
              type='button'
              role='tab'
              aria-selected={tab.code === tabCode}
              className={`${classes.commissionTab} ${tab.code === tabCode ? classes.commissionTabOn : ''}`}
              onClick={() => {
                setTabCode(tab.code)
                setScopeCode('')
              }}
            >
              {tab.name}
            </button>
          ))}
        </div>
      )}

      {scopes.length > 1 && (
        <div className={classes.commissionChips}>
          {scopes.map(scope => (
            <button
              key={scope.code}
              type='button'
              className={`${classes.commissionChip} ${
                scope.code === activeScope.code ? classes.commissionChipOn : ''
              }`}
              onClick={() => setScopeCode(scope.code)}
            >
              {scope.name}
            </button>
          ))}
        </div>
      )}

      {/* Kampanya detayı: ad · şirket · geçerlilik. Depo, ürün alt tipi ve kota BİLEREK yok. */}
      {detail.length > 0 && (
        <p className={classes.commissionNote}>
          <strong>{detail[0]}</strong>
          {detail.slice(1).map(part => ` · ${part}`)}
        </p>
      )}

      <div className={classes.commissionBody}>
        {rows.map(row => (
          <div key={row.installment} className={classes.commissionBestRow}>
            <span className={classes.commissionBestLabel}>{formatInstallmentLabel(row.installment)}</span>
            <span className={classes.commissionRate}>{formatChatRate(row.interestRate)}</span>
          </div>
        ))}
      </div>

      {rates.note && <p className={classes.commissionNote}>{rates.note}</p>}
    </div>
  )
}
